<script>

import { mapGetters, mapActions } from "vuex";
import { required, minLength, maxLength, sameAs } from "vuelidate/lib/validators"; // for validators
import {swal} from '../../../helpers/handle_error.js';
import AlertError from '@/components/alert_error'
import Admin from '../../../model/admin.js';

export default {
  components: { AlertError},
  data() {
    return {
      //Page errors.
      errors: [],

      // vuelidate
      admin: new Admin,
      submitadd: false,
      loadingButton: false,
    };
  },
  // vuelidate
  validations: {
     admin: {
      name: {required, minLength: minLength(2), maxLength: maxLength(150)},
      username: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(30),
        async isUnique(value) {
          // standalone validator ideally should not assume a field is required
          if (value === '') return true
          const response = await this.checkUserName({
            username: this.admin.username
          });
          return Boolean(await response.data)
        }//end isUnique function.
      },
      description: {maxLength: maxLength(255)},
      active: {required},
      password: { required, minLength: minLength(8), maxLength: maxLength(50) },
      confirm_password: { required, sameAsPassword: sameAs("password") },
    },
  },
  computed: {
    ...mapGetters('admin', {roles: 'getRoles'}),
  },
  methods: {
    ...mapActions('admin', ['add', 'getRoles']),
    ...mapActions('auth', ['checkUserName']),
    handleError(error){
      if(error.response.status == 422) this.errors = Object.values(error.response.data.errors)
      else this.errors = [`Error Code : ${error.response.status}  Message : ${error.response.data.message}`]
    },
    resetForm(){
      this.submitadd = false
      this.loadingButton = false
      this.errors = []
      this.admin.reset()
    },
    formAddAdmin() { 
      this.submitadd = true
      this.$v.$touch();
      if(this.$v.$error) return

      // to form submit after this
      this.loadingButton = true
      this.errors = [];

      this.add(this.admin)
      .then((response)=>{
        swal.success(response.data.message)
        this.resetForm()
      })
      .catch((error)=>{
        this.handleError(error)
        this.loadingButton = false
      })
    },
    testUnit(){
      this.admin.name = 'test name'
      this.admin.description = 'test description'
      this.admin.username = 'user2'
      this.admin.active = 1
      this.admin.password = '12345678'
      this.admin.confirm_password = '12345678'
      this.admin.permissions = this.roles.flatMap(r=>r.permissions.map(p=>p.id))
    }
  },
  created(){
    this.getRoles()
    .then(()=>{
      if(process.env.NODE_ENV == "development") {
        this.testUnit()
      }
    })
  }
};
</script>

<template>

    <b-form @submit.prevent="formAddAdmin">

      <AlertError :errors="errors" />

      <div class="row mt-3">
        <b-form-group class="col-md-4 mb-3" label="الاسم :" label-for="name">
            <b-form-input id="name" type="text" v-model="admin.name" :class="{ 'is-invalid': submitadd && $v.admin.name.$error }" placeholder="ادخل الاسم"></b-form-input>
            <div v-if="submitadd && $v.admin.name.$error" class="invalid-feedback">
              <span v-if="!$v.admin.name.required"> هذا الحقل الزامي </span>
              <span v-if="!$v.admin.name.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 2 احرف على الاقل . </span>
              <span v-if="!$v.admin.name.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 150 حرف على الاكثر . </span>
            </div>
        </b-form-group>
        <b-form-group class="col-md-4 mb-3" label="الوصف  :" label-for="description">
            <b-form-input id="description" type="text" v-model="admin.description" :class="{ 'is-invalid': submitadd && $v.admin.description.$error }" placeholder="ادخل الوصف"></b-form-input>
            <div v-if="submitadd && $v.admin.description.$error" class="invalid-feedback">
              <span v-if="!$v.admin.description.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 255 حرف على الاكثر . </span>
            </div>
        </b-form-group>
        <b-form-group class="col-md-4 mb-3" label="تفعيل الحساب :" label-for="active">
            <select class="form-control select-p" v-model="admin.active" :class="{ 'is-invalid': submitadd && $v.admin.active.$error }" id="active">
              <option value="">حدد تفعيل الحساب</option>
              <option value="1">مفعل</option>
              <option value="0">غير مفعل</option>
            </select>
            <div v-if="submitadd && $v.admin.active.$error" class="invalid-feedback">
              <span v-if="!$v.admin.active.required"> هذا الحقل الزامي </span>
            </div>
        </b-form-group>
        <b-form-group class="col-md-4 mb-3" label="اسم المستخدم :" label-for="username">
            <b-form-input id="username" type="text" v-model="admin.username" :class="{ 'is-invalid': submitadd && $v.admin.username.$error }" placeholder="ادخل اسم المستخدم"></b-form-input>
            <div v-if="submitadd && $v.admin.username.$error" class="invalid-feedback">
              <span v-if="!$v.admin.username.required"> هذا الحقل الزامي </span>
              <span v-if="!$v.admin.username.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 3 احرف على الاقل .</span>
              <span v-if="!$v.admin.username.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 30 حرف على الاكثر . </span>
              <span v-if="!$v.admin.username.isUnique"> اسم المستخدم هذا غير متوفر . </span>
            </div>
        </b-form-group>
        <b-form-group class="col-md-4 mb-3" label="كلمة المرور :" label-for="password">
            <b-form-input id="password" type="text" v-model="admin.password" :class="{ 'is-invalid': submitadd && $v.admin.password.$error }" placeholder="ادخل كلمة المرور"></b-form-input>
            <div v-if="submitadd && $v.admin.password.$error" class="invalid-feedback">
              <span v-if="!$v.admin.password.required"> هذا الحقل الزامي </span>
              <span v-if="!$v.admin.password.minLength"> قيمة هذا الحقل قصيرة جداً. يجب ان يتكون من 8 احرف على الاقل . </span>
              <span v-if="!$v.admin.password.maxLength"> قيمة هذا الحقل طويلة جداً. يجب ان يتكون من 50 حرف على الاكثر . </span>
            </div>
        </b-form-group>
        <b-form-group class="col-md-4 mb-3" label="تأكيد كلمة المرور :" label-for="confirm_password">
            <b-form-input id="confirm_password" type="text" v-model="admin.confirm_password" :class="{ 'is-invalid': submitadd && $v.admin.confirm_password.$error }" placeholder="ادخل كلمة المرور"></b-form-input>
            <div v-if="submitadd && $v.admin.confirm_password.$error" class="invalid-feedback">
              <span v-if="!$v.admin.confirm_password.required"> هذا الحقل الزامي </span>
              <span v-if="!$v.admin.confirm_password.sameAsPassword"> كلمة المرور غير متطابقة </span>
            </div>
        </b-form-group>
      </div>

      <hr class="mt-4"> <div class="break-title"><h5>منح الصلاحيات</h5></div> 

      <div class="row">
        <div class="col-md-3 dis-flex" v-for="role in this.roles" v-bind:key="role.id">
          <div class="con-border pb-2 mt-4">
            <h5>{{role.title}}</h5>
            <b-form-checkbox class="mb-1" 
              v-for="permission in role.permissions" v-bind:key="permission.id"
              v-model="admin.permissions"
              :id="'permission_'+permission.id"
              :value="permission.id" plain >{{permission.title}}</b-form-checkbox>
          </div>
        </div>
      </div>

      <div class="">
        <hr>
        <b-button :disabled="loadingButton" class="btn-block" type="submit" variant="primary"> 
          <b-spinner v-if="loadingButton" small></b-spinner>
          <span v-else>
            <i class="bx bx-check font-size-16 align-middle me-2"></i>حفظ
          </span>
        </b-button>
      </div>

    </b-form>
              
</template>